/**
 * Naming Convention Utilities
 * Handles text transformation according to various naming conventions
 */

import { NamingConvention } from '../../../types/exportTemplates';

/**
 * Apply naming convention to a string
 */
export function applyNamingConvention(text: string, convention: NamingConvention): string {
  if (!text) return '';
  
  // For 'original' convention, return the text as-is (preserving exact casing)
  // Only replace characters that are invalid for identifiers
  if (convention === 'original') {
    return text.replace(/[^a-zA-Z0-9_]/g, '_');
  }
  
  // Remove special characters and split into words
  const words = text
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0);
  
  if (words.length === 0) return '';
  
  switch (convention) {
    case 'PascalCase':
      return words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');
    
    case 'camelCase':
      return words
        .map((word, index) => {
          if (index === 0) {
            return word.toLowerCase();
          }
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join('');
    
    case 'snake_case':
      return words.map(word => word.toLowerCase()).join('_');
    
    case 'SCREAMING_SNAKE_CASE':
      return words.map(word => word.toUpperCase()).join('_');
    
    default:
      return text;
  }
}
